module.exports = __webpack_public_path__ + "static/media/Alert.322b16c8.svg";